import { adminSupportQueryKeys as e } from "../supportQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/admin/useAdminFaqsQuery.ts
var r = () => t({
	queryKey: e.faqs(),
	queryFn: () => n.adminListFaqs()
});
//#endregion
export { r as useAdminFaqsQuery };
